var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320.1 320.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.7,182.7c12.5-12.5,12.5-32.8,0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9S64,19.1,64,32.1v256 c0,12.9,7.8,24.6,19.8,29.6s25.7,2.2,34.9-6.9l128-128V182.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRightSolid);
export default __webpack_public_path__ + "static/media/caret-right-solid.5d6a50b62994f3c95825ac35c6dbb3b3.svg";
export { ForwardRef as ReactComponent };